import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Grid2 as Grid, Typography } from '@mui/material';
import {
  WTable,
  WBaseTable,
  WActionsTableButton,
  WTablePagination,
} from '@wareclouds/wareclouds-ui';

import { useTableStatusMessages } from '../../common';
import {
  useRouteHistoryTableColumns,
  useRouteHistoryTableActions,
} from './hooks';
import { useGetRoutesHistory } from '../services';
import { defaultRouteHistoryFilters } from './components/schemas';
import { RoutesHistoryFilters, RoutesDetailsModal } from './components';

export default function RoutesHistoryPage() {
  const { t } = useTranslation(['title']);

  const [filters, setFilters] = useState(defaultRouteHistoryFilters);
  const [selectedRoute, setSelectedRoute] = useState(null);
  const [showRouteDetailsModal, setShowRouteDetailsModal] = useState(false);

  const { columns } = useRouteHistoryTableColumns();
  const { actions, actionHeader } = useRouteHistoryTableActions({
    setShowRouteDetailsModal,
    setSelectedRoute,
  });
  const { errorProps, emptyProps } = useTableStatusMessages();

  const { data, isLoading, isError, isFetching } = useGetRoutesHistory(filters);

  const handleSubmit = (data) => {
    setFilters(data);
  };

  const onPageChange = (newPage) => {
    setFilters({ ...filters, page: newPage + 1 });
  };

  return (
    <Container maxWidth={'xl'} sx={{ paddingY: 3 }}>
      <Grid container justifyContent="space-between">
        <Grid item>
          <Typography variant="h4">
            {t('routes.history', { ns: 'title' })}
          </Typography>
        </Grid>
      </Grid>

      <RoutesHistoryFilters
        onSubmit={handleSubmit}
        setFilters={setFilters}
        defaultFilters={defaultRouteHistoryFilters}
      />

      <WBaseTable
        isInitialLoading={isLoading}
        isError={isError}
        isLoading={isFetching}
        tableColumns={columns}
        tableData={data?.data}
        columnCount={columns?.length}
        componentsProps={{ error: errorProps, empty: emptyProps }}
      >
        <WTable
          actionHeader={actionHeader}
          renderActions={(element) => (
            <WActionsTableButton actions={actions} element={element} />
          )}
        />
        <WTablePagination onPageChange={onPageChange} />
      </WBaseTable>

      <RoutesDetailsModal
        show={showRouteDetailsModal}
        handleClose={() => setShowRouteDetailsModal(false)}
        cities={selectedRoute?.cities}
        totalOrders={selectedRoute?.totalOrders}
      />
    </Container>
  );
}
